import './styles/global.scss'

import * as firebase from 'firebase'
import * as React from 'react'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import { ThemeProvider } from 'styled-components'
import AccountPage from './pages/AccountPage'
import BeforeLaunchPage from './pages/BeforeLaunchPage'
import ChangesPage from './pages/ChangesPage'
import DevPage from './pages/DevPage'
import ErrorPage from './pages/ErrorPage'
import ExplorePage from './pages/ExplorePage'
import HelpPage from './pages/HelpPage'
import HomePage from './pages/HomePage'
import LectureContentPage from './pages/LectureContentPage'
import LecturePage from './pages/LecturePage'
import MyLecturePage from './pages/MyLecturePage'
import OrderHistoryPage from './pages/OrderHistoryPage'
import OrderPage from './pages/OrderPage'
import PaymentPage from './pages/PaymentPage'
import PaymentSuccessPage from './pages/PaymentSuccessPage'
import ProfilePage from './pages/ProfilePage'
import RecruitPage from './pages/RecruitPage'
import TermsPage from './pages/TermsPage'
import ScrollToTop from './ScrollToTop'
import { dispatch } from './store'

const theme = {
  space: [0, 4, 8, 12, 16],
  breakpoints: ['32em', '48em', '64em']
}

class App extends React.Component {
  constructor(props: React.Props<{}>) {
    super(props)
    // auth checking
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        dispatch.auth.authStart()
        dispatch.auth
          .updateUser(user)
          .then(dispatch.auth.authSuccess)
          .then(dispatch.orders.fetchOrders)
          .then(dispatch.notifications.fetchNotifications)
          .then(dispatch.auth.closeAuthModal)
      }
    })
    // verified lectures fetching
    dispatch.lectures.fetchLectures()
    // fetch participants
    dispatch.participants.fetchParticipants()
    // recommend lectures fetching
    dispatch.recommends.fetchRecommends()
  }
  public render() {
    return (
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <ScrollToTop>
            <Switch>
              <Route path="/" exact={true} component={HomePage} />
              <Route path="/dev" component={DevPage} />
              <Route path="/account" component={AccountPage} />
              <Route path="/payment" component={PaymentPage} />
              <Route
                path="/orders/"
                exact={true}
                component={OrderHistoryPage}
              />
              <Route path="/orders/:orderId" component={OrderPage} />
              <Route
                path="/lectures/:lectureId/edit"
                exact={true}
                component={BeforeLaunchPage}
              />
              <Route path="/lectures/" exact={true} component={MyLecturePage} />
              <Route
                path="/lectures/:lectureId"
                exact={true}
                component={LecturePage}
              />
              <Route
                path="/lectures/:lectureId/content"
                component={LectureContentPage}
              />
              <Route path="/recruit" component={RecruitPage} />
              <Route path="/terms" component={TermsPage} />
              <Route path="/explore" component={ExplorePage} />
              <Route path="/users/:userId" component={ProfilePage} />
              <Route path="/help" component={HelpPage} />
              <Route path="/paymentSuccess" component={PaymentSuccessPage} />
              <Route path="/changes" component={ChangesPage} />
              <Route component={ErrorPage} />
            </Switch>
          </ScrollToTop>
        </BrowserRouter>
      </ThemeProvider>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.tsx